import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export default function AuthCallback() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { loginSuccess } = useStore();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    const back = sessionStorage.getItem("skd_after_login") || "/account";
    sessionStorage.removeItem("skd_after_login");
    api.post("/auth/google", { session_id: sessionId })
      .then(async ({ data }) => {
        await loginSuccess(data.token, data.user);
        toast.success(`Welcome${data.user.name ? ", " + data.user.name : ""}!`);
        navigate(data.user.role === "admin" && back === "/account" ? "/admin" : back, { replace: true });
      })
      .catch((e) => {
        toast.error(e.response?.data?.detail || "Google sign-in failed. Please try again.");
        navigate("/", { replace: true });
      });
  }, []); // eslint-disable-line

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center bg-[#120A07] text-[#C8B8AB] text-sm">Signing you in…</div>
  );
}
